'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { ExpenseReport_ExpenseReportStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { BudgetStatementLastUpdate } from '@/modules/expense-reports/components/budget-statement-last-update';
import { MonthNavigation } from '@/modules/expense-reports/components/month-navigation';
import { useMonthNavigation } from '@/modules/expense-reports/components/month-navigation/use-month-navigation';
import { isSameMonth } from '@/modules/expense-reports/lib/month-utils';
import { BudgetStatementsStatus } from '@/modules/finances/components/budget-statements-section/budget-statements-status/budget-statements-status';
export interface BudgetStatementsPageHeaderProps {
  availableMonthsWithMetadata: Array<{
    month: string;
    status: string | null;
    lastUpdate: string | null;
  }>;
  /** Fallback month for the hook when the URL has no viewMonth (used only by useMonthNavigation). */
  defaultMonthIso: string;
}
function BudgetStatementsPageHeader(t0) {
  const $ = _c(28);
  const {
    availableMonthsWithMetadata,
    defaultMonthIso
  } = t0;
  let t1;
  if ($[0] !== availableMonthsWithMetadata) {
    t1 = availableMonthsWithMetadata.map(_temp);
    $[0] = availableMonthsWithMetadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const months = t1;
  let t2;
  if ($[2] !== defaultMonthIso) {
    t2 = new Date(defaultMonthIso);
    $[2] = defaultMonthIso;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== months || $[5] !== t2) {
    t3 = {
      availableMonths: months,
      defaultMonth: t2
    };
    $[4] = months;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    availableMonths,
    defaultMonth
  } = t3;
  let t4;
  if ($[7] !== availableMonths || $[8] !== defaultMonth) {
    t4 = {
      availableMonths,
      defaultMonth
    };
    $[7] = availableMonths;
    $[8] = defaultMonth;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    selectedMonth
  } = useMonthNavigation(t4);
  let t5;
  if ($[10] !== availableMonthsWithMetadata || $[11] !== selectedMonth) {
    let t6;
    if ($[13] !== selectedMonth) {
      t6 = meta => isSameMonth(new Date(meta.month), selectedMonth);
      $[13] = selectedMonth;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = availableMonthsWithMetadata.find(t6);
    $[10] = availableMonthsWithMetadata;
    $[11] = selectedMonth;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const currentEntry = t5;
  let t6;
  if ($[15] !== availableMonths || $[16] !== defaultMonth) {
    t6 = <MonthNavigation availableMonths={availableMonths} defaultMonth={defaultMonth} />;
    $[15] = availableMonths;
    $[16] = defaultMonth;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== currentEntry) {
    t7 = currentEntry?.status != null && <BudgetStatementsStatus status={currentEntry.status as ExpenseReport_ExpenseReportStatus} />;
    $[18] = currentEntry;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="flex flex-col gap-2 sm:flex-row sm:items-center">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const t9 = currentEntry?.lastUpdate ?? null;
  let t10;
  if ($[23] !== t9) {
    t10 = <BudgetStatementLastUpdate lastModifiedAtUtcIso={t9} />;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = <div className="flex w-full items-start justify-between gap-4">{t8}{t10}</div>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
function _temp(m) {
  return new Date(m.month);
}
export { BudgetStatementsPageHeader };